import { useEffect } from 'react';
import { matchPath, useLocation } from 'react-router-dom';
import { screenByBoard } from '@screens';
import { locateScreen, navigationGroups } from '../config/navigation';
import { useBoardChrome } from '../canvas/dc/boardChrome';

export const APP_TITLE = 'WareHouse';

const navItems = navigationGroups.flatMap((g) => g.items);

/** Page name for a shell route: the mounted design board, else the canvas screen, else the nav item. */
export function shellTitleFor(pathname: string, board: string | null): string | null {
  if (board) return screenByBoard(board)?.name ?? board;
  const located = locateScreen(pathname);
  if (located) return located.screen.name;
  const item = navItems.find((i) => matchPath({ path: i.href, end: true }, pathname));
  return item?.name ?? null;
}

/** Keeps document.title as "<screen name> · WareHouse" for every route in the app shell. */
export function useShellDocumentTitle(): void {
  const { pathname } = useLocation();
  const board = useBoardChrome((s) => s.board);
  useEffect(() => {
    const name = shellTitleFor(pathname, board);
    document.title = name ? `${name} · ${APP_TITLE}` : APP_TITLE;
  }, [pathname, board]);
}
